/**
 * @generated SignedSource<<ea8e0912b2d97e15decb2fcc156d5829>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoredFile_file$data = {
  readonly fileName: string;
  readonly size: number;
  readonly " $fragmentType": "StoredFile_file";
};
export type StoredFile_file$key = {
  readonly " $data"?: StoredFile_file$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoredFile_file">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StoredFile_file",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "size",
      "storageKey": null
    }
  ],
  "type": "StoredFile",
  "abstractKey": null
};

(node as any).hash = "764db39a248d58cc8f9318cf511bfd45";

export default node;
